var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review"},[_vm._l((5),function(i){return _c('i',{key:i,staticClass:"fa fa-star mr-1",class:i <= _vm.value ? 'text-yellow-400' : 'text-gray-400'})}),_c('span',{staticClass:"text-sm"},[_vm._v(" (100 reviews) ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }